import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {merchantsEdit_template} from "../components/templates/merchantsEdit_template";
import {imagePickerHelper} from '../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';

declare var ko: any;
declare var page: any;

export class merchant_edit extends vnModule_knockoutJS {

    protected merchantsEditTemplate: merchantsEdit_template;
    protected categoriesData: any[] = [];
    public imagePickerHelper: imagePickerHelper;

    protected getModuleName(): string {
        return "merchant_edit";
    }

    public getIdBrand() {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    buildContent(): Element[] {
        this.merchantsEditTemplate = new merchantsEdit_template("merchantsEditTemplate", this.viewModel, this);

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Merchant Form");

        return [this.merchantsEditTemplate.build()];
    }

    fillPage(): void {
        this.getReferences();
    }

    protected getReferences(): void {
        if (this.XHRHdls['getReferences']) {
            this.XHRHdls['getReferences'].cancelAndReset();
        }
        this.loadingIn(this.merchantsEditTemplate.builtTemplate);

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/references/';
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);

        this.XHRHdls['getReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getReferences'].onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdls['getReferences'].execute();
    }

    protected onGetReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);

                if (response.categories) {
                    obj.categoriesData = response.categories;
                    const flatCategories = obj.flattenCategories(response.categories);
                    obj.merchantsEditTemplate.setCategoryOptions(flatCategories);
                }

                obj.getFormData();
            });
        };
    }

    protected flattenCategories(categories: any[], parentName: string = ''): any[] {
        let flat: any[] = [];
        for (const cat of categories) {
            const displayName = parentName ? `${parentName} > ${cat.name}` : cat.name;
            flat.push({ id: cat.id, name: displayName });
            if (cat.children && cat.children.length > 0) {
                flat = flat.concat(this.flattenCategories(cat.children, displayName));
            }
        }
        return flat;
    }

    protected getFormData(): void {
        const merchantId = this.getVnAppZone().app.params.merchantId;

        if (this.XHRHdls['getFormData']) {
            this.XHRHdls['getFormData'].cancelAndReset();
        }

        if (merchantId && !isNaN(merchantId)) {
            this.viewModel["merchantsEditTemplate"].id(merchantId);

            const idBrand = this.getVnAppZone().app.params.idBrand;
            const usrReq_url: string = '/api/discounts/merchants/get/' + merchantId + '/';
            const usrReq_params: string[][] = [];
            usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);

            this.XHRHdls['getFormData'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdls['getFormData'].onReadyStateFunction = this.onGetFormDataReturn;
            this.XHRHdls['getFormData'].execute();
        } else {
            this.loadingOut(this.merchantsEditTemplate.builtTemplate);
        }
    }

    protected onGetFormDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);

                if (response.merchant != null) {
                    obj.merchantsEditTemplate.setMerchantData(response.merchant);
                } else if (response.id != null) {
                    obj.merchantsEditTemplate.setMerchantData(response);
                }

                obj.loadingOut(obj.merchantsEditTemplate.builtTemplate);
            });
        };
    }

    protected save(): void {
        if (this.XHRHdls['save']) {
            this.XHRHdls['save'].cancelAndReset();
        }

        this.loadingIn(this.merchantsEditTemplate.builtTemplate);

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const merchantId = this.viewModel["merchantsEditTemplate"].id();
        const formReq_url: string = merchantId ? '/api/discounts/merchants/save/' + merchantId + '/' : '/api/discounts/merchants/save/';
        const formReq_params: string[][] = [];

        const viewModelData = this.merchantsEditTemplate.getViewModelForRequest();
        viewModelData.brandId = idBrand;

        formReq_params.push(["data", ko.toJSON(viewModelData)]);

        this.XHRHdls['save'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls['save'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['save'].onReadyStateFunction = this.onPostMerchantReturn;
        this.XHRHdls['save'].execute();
    }

    protected onPostMerchantReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                const url: string = '/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/merchants/';

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Merchant saved successfully!");
                obj.merchantsEditTemplate.clearMessages();

                page.redirect(url);
            });
            obj.loadingOut(obj.merchantsEditTemplate.builtTemplate);
        };
    }

    public cancelForm() {
        this.cancel();
    }

    public cancel(): void {
        const url: string = '/brand/' + this.getVnAppZone().app.params.idBrand + '/config/merchants/';

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Merchant Action Canceled!");
        this.merchantsEditTemplate.clearMessages();

        page.redirect(url);
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected filterDropdownOnChange(idElement) {
        // Handle dropdown changes if needed
    }

    protected filterSimpleOnChange(idElement) {
        // Handle filter changes if needed
    }

    protected filterSimpleCancel() {
        // Handle filter cancellation
    }

    protected filterMultipleSelectorOnChange(idElement = null) {
        this.merchantsEditTemplate.updateSelectedCategories();
    }

    protected insertImage(image, target, extra_option) {
        if (target === "merchant_logo") {
            this.merchantsEditTemplate.setLogoImage(image);
        }
    }

    public removeImage(target) {
        this.merchantsEditTemplate.removeImage(target);
    }

    public setIsImageOptimized(val) {
        // Implement if needed
    }
}



// WEBPACK FOOTER //
// ./js/modules/merchant_edit.ts